import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import logo from "../assets/imgs/logo.png";
import home from "../assets/imgs/home.svg";
import home1 from "../assets/imgs/home1.png";

const menu = [
  { label: "Giới thiệu dịch vụ", href: "/gioithieu" },
  { label: "Hướng dẫn sử dụng", href: "/service" },
  { label: "Hướng dẫn đăng ký dịch vụ", href: "/register" },
  { label: "Chính sách bảo vệ thông tin khách hàng", href: "/chinhSach" },
  { label: "Cài đặt dịch vụ", href: "/dieukhoan" },
];

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathname = location.pathname;
  const hash = location.hash;

  const isHomeActive = pathname === "/";
  const [open, setOpen] = useState(false);
  const isHomeActiveMobile = pathname === "/";

  const renderMenuItem = (item, index) => {
    const isAnchor = item.href.includes("#");
    const anchorId = isAnchor ? item.href.split("#")[1] : null;

    let isActive = false;
    if (isAnchor) {
      isActive = pathname === "/" && hash === `#${anchorId}`;
    } else {
      isActive = pathname === item.href;
    }

    const className = `block lg:flex px-4 py-3 font-bold h-full text-base items-center text-left lg:text-center lg:uppercase  border-b-2 lg:border-none
    ${isActive ? "bg-[linear-gradient(134.3deg,_#42DDA5_49.75%,_#1679CF_99.48%)] lg:bg-none text-white lg:text-[#1F7ED0]" : "text-[#4D4E50] hover:text-blue-200"}
    ${index !== 0 ? "lg:border-l lg:border-[#ACABAB]" : ""}
  `;

    if (item.href === "/dieukhoan") {
      return (
        <a
          key={item.label}
          href="http://tienich.vinaphone.com.vn"
          target="_blank"
          rel="noopener noreferrer"
          className={className}
        >
          {item.label}
        </a>
      );
    }

    return (
      <Link
        key={item.label}
        to={item.href}
        className={className}
        onClick={() => setOpen(false)}
        style={{
    borderImage: "linear-gradient(134.3deg, #42DDA5 49.75%, #1679CF 99.48%) 1",
  }}
      >
        {item.label}
      </Link>
    );
  };

  return (
    <header className="bg-white fixed top-0 left-0 w-full z-50">
      <div className="relative lg:w-4/5 mx-auto px-8 lg:px-4 h-16 flex items-center">

    {/* MOBILE HAMBURGER */}
    <div className="lg:hidden">
      <IconButton
        onClick={() => setOpen(!open)}
        sx={{ width: 24, height: 24, padding: 0 }}
      >
        <MenuIcon sx={{ fontSize: 24, color: "#1F7ED0" }} />
      </IconButton>
    </div>

    {/* LOGO */}
    <Link
      to="/"
      className="absolute left-1/2 -translate-x-1/2 lg:static lg:translate-x-0 flex items-center"
    >
      <img src={logo} alt="VNPT" className="h-10 w-auto" />
    </Link>

    {/* DESKTOP MENU */}
    <nav className="hidden lg:flex items-center h-6 ml-auto">
      <span className="h-full border-r border-[#ACABAB]" />
      <Link to="/" className="px-3 flex items-center">
        <img src={isHomeActive ? home : home1} className="w-4 h-4" alt="home" />
      </Link>
      <span className="h-full border-l border-[#ACABAB]" />
      {menu.map(renderMenuItem)}
    </nav>

  </div>

      {/* MOBILE MENU */}
      {open && (
        <>
          <div
            className="fixed top-16 left-0 right-0 bottom-0 bg-black/40 z-40"
            onClick={() => setOpen(false)}
          />

          {/* DRAWER */}
          <div className="fixed top-16 left-8 h-max w-[260px] bg-white z-50 shadow-lg">
            <div className="flex flex-col">
              <Link
                to="/"
                className={`block lg:hidden px-4 py-3 font-bold h-full text-base items-center text-left lg:text-center lg:uppercase border-b-2
    ${isHomeActiveMobile ? "bg-[linear-gradient(134.3deg,_#42DDA5_49.75%,_#1679CF_99.48%)] text-white lg:text-[#1F7ED0]" : "text-[#4D4E50] "}`}
                onClick={() => setOpen(false)}
                style={{
    borderImage: "linear-gradient(134.3deg, #42DDA5 49.75%, #1679CF 99.48%) 1",
  }}  
              >
                Trang chủ
              </Link>

              {menu.map(renderMenuItem)}
            </div>
          </div>
        </>
      )}
    </header>
  );
};

export default Header;
